import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {Box, makeStyles} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {},
    importButton: {
        marginRight: theme.spacing(1)
    },
    exportButton: {
        marginRight: theme.spacing(1)
    }
}));
/**
 *
 * テーブルビューの前のコンポーネント
 *
 * @param className
 * @param toggleRegisterView
 * @param searchLoad
 * @param searchUserResult
 * @param searchUser
 * @param t
 * @param rest
 * @returns {JSX.Element}
 * @deprecated - 自動提案ボックスが戻ってこなければ、削除される予定です。
 * @constructor
 */
const Toolbar = ({className, toggleRegisterView, searchLoad, searchUserResult, searchUser, t, ...rest}) => {
    const classes = useStyles();

    return (
        <div
            className={clsx(classes.root, className)}
            {...rest}
        >
            <Box
                display="flex"
                justifyContent="flex-end"
            >
            </Box>
        </div>
    );
};

Toolbar.propTypes = {
    className: PropTypes.string
};

export default Toolbar;
